jQuery(document).ready(function($) {
    var reelSliderWrapper = $('.reel-slider-wrapper');

    function isInViewport(element) {
        var elementTop = $(element).offset().top;
        var elementBottom = (elementTop + $(element).outerHeight()) / 3;
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    // Debaunce function for touchpad sesitivity on slide
    function debounce(func, wait) {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeout);
            if($(window).width() > 768){
                timeout = setTimeout(function () {
                    func.apply(context, args);
                }, wait);
            } else {
                func.apply(context, args);
            }
        };
    }

    function handleSlider(element, wheel = true, overflow = 'hidden') {
        if(element.length !== 0) {

            var settings = {
                vertical: true,
                verticalSwiping: true,
                swipeToSlide:true,
                dots: false,
                arrows: false,
                infinite: false, // Disable infinite looping
                slidesToShow: 1,
                slidesToScroll: 1,
                wheelSpeed: 22
            }

            document.body.style.overflowY = overflow;

            if($(window).width() < 992){
                $(element).css('height', $(window).height() - 135 + 'px');
            }

            // Start always on top
             if($(window).scrollTop() > 0){
                document.body.style.overflowY = 'scroll';
                $('html,body').animate({
                    scrollTop:0,
                }, 0, function(){
                    document.body.style.overflowY = overflow;
                });
             }

            function handleWheel (e) {
                e.preventDefault();

                if(!wheel) return;

                if (e.originalEvent.deltaY < 0) {
                    $(this).slick('slickPrev');
                } else {
                    $(this).slick('slickNext');
                }
            }

            var lastScrollTop = 0;
            var isAnimating = false;
            var lastSlickSlide = false;

            function handleAfterChange (event, slick, currentSlide) {
                if (currentSlide === slick.slideCount - 1) {
                    // Enable scrolling on the body when the last slide is reached
                    element.off('wheel', handleWheel);
                    element.slick('slickSetOption', 'verticalSwiping', false);
                    document.body.style.overflowY = 'scroll';
                    lastSlickSlide = true;
                } else{
                    element.slick('slickSetOption', 'verticalSwiping', true);
                    lastSlickSlide = false;
                }
            }

            function handleScroll(e) {
                let currentScrollTop = $(this).scrollTop();
                if(!wheel) return;

                if (currentScrollTop > lastScrollTop) {
                } else {
                    if (!isAnimating && isInViewport(element)) { // Check if the animation is not running
                        isAnimating = true; // Set the flag to indicate that the animation is running

                        $('html,body').animate({
                            scrollTop:0,
                        }, 300, function(){
                            if($(this).scrollTop() === 0) {
                                element.slick('slickGoTo', 0);
                                element.slick('slickSetOption', 'verticalSwiping', true);
                                element.on('wheel', debounce(handleWheel, settings.wheelSpeed));
                                document.body.style.overflowY = overflow;
                                isAnimating = false;
                            }
                        });
                    }
                }
                lastScrollTop = currentScrollTop;
            }
            window.on('scroll', handleScroll);

            element.slick(settings).on('afterChange', handleAfterChange ).on('wheel', debounce(handleWheel, settings.wheelSpeed));
        }
    }

    if (Shopify.designMode) {
        function handleShopifyThemeCutomizer(event){
            const sectionSelectedIsReelSlider = event.target.classList.contains('reel-section');

            if(!sectionSelectedIsReelSlider) return;

            reelSliderWrapper = $(event.target).find('.reel-slider-wrapper');
            handleSlider(reelSliderWrapper, false, 'scroll');
        }

        document.addEventListener('shopify:section:load', handleShopifyThemeCutomizer);
        document.addEventListener('shopify:section:select', handleShopifyThemeCutomizer);
        document.addEventListener('shopify:section:reorder', handleShopifyThemeCutomizer);
    } else {
        handleSlider(reelSliderWrapper);
    }
    });


